export default "__VITE_ASSET__C5CZDV1N__"